import React, { useState } from 'react';
import { Divider, FormHelperText, Radio, InputAdornment, TextField, Typography, MuiThemeProvider, createMuiTheme, withStyles, Tooltip, Switch } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import IcDelete from '../../assets/ic_delete.png';
import IcButton from '../../assets/icon_button.png';
import editIcon from '../../assets/1@3x.png';
import { format } from 'date-fns';
import api from '../api';
import { green } from '@material-ui/core/colors';
import { useHistory } from 'react-router-dom';
import { AirlineSeatIndividualSuiteSharp } from '@material-ui/icons';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable5());

const options = ct.customOptionsNofilSearch();

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function AddSkrining(props) {
    console.log(props.data);
    const history = useHistory()
    const classes = useStyles();
    const dispatch = useDispatch();
    const [newPasien, setNewPasien] = useState({
        jenisKelamin: ""
    })
    const [namaPasien, setNamaPasien] = useState(null)
    const [idReservasi, setIDReservasi] = useState(null)
    const [phone, setPhone] = useState("")
    const [gender, setGender] = useState(null)
    const [alamat, setAlamat] = useState("")
    const [rekamMedis, setRekamMedis] = useState("")
    const [tglLahir, setTglLahir] = useState(null);
    const listJenkel = [
        { value: 'Laki-laki', id: 'L' },
        { value: 'Perempuan', id: 'P' },
    ]
    const [asuransiLength, setAsuransiLength] = useState([]);
    const [namaBPJS, setNamaBPJS] = useState("")
    const [noBPJS, setNoBPJS] = useState("")

    const [namaPengunjung, setNamaPengunjung] = React.useState(null);
    const [textNama, setTextNama] = React.useState("");
    const [errorNama, setErrorNama] = React.useState(false);
    const [textPhone, setTextPhone] = React.useState("");
    const [errorPhone, setErrorPhone] = React.useState(false);
    const [textNoKTP, setTextNoKTP] = React.useState("");
    const [errorNoKTP, setErrorNoKTP] = React.useState(false);
    const [textAlamat, setTextAlamat] = React.useState("");
    const [errorAlamat, setErrorAlamat] = React.useState(false);
    const [errorGender, setErrorGender] = React.useState(false);
    const [is_already, set_is_already] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [messageError, setMessageError] = React.useState(null);
    const [skriningResult, setSkriningResult] = React.useState([]);
    const [list, setList] = React.useState([]);
    const [allData, setAllData] = React.useState([]);

    

    React.useEffect(() => {
        getDataSkrining()
        // forceUpdate()
        // getAllData()
    }, [])

    React.useEffect(() => {
        getData()
        // if (idReservasi || namaPasien || tglLahir) {
        // }
    }, [namaPasien, idReservasi, tglLahir])

    console.log(skriningResult);

    const getDataSkrining = () => {
        api.create().getTransactionScrenning().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setSkriningResult(response.data.data)
                    getAllData(response.data.data)
                }
            }
        })
    }

    const getAllData = (skrining) => {
        console.log(skrining);
        let tanggalNow = new Date().getDate()
        let bulanNow = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
        let bulanNowPlus = new Date().getMonth() + 2 < 10 ? `0${new Date().getMonth() + 2}` : new Date().getMonth() + 2
        let tahunNow = new Date().getFullYear()
        let dateNow = `${tahunNow}-${bulanNow}-${tanggalNow}`
        let dateNowPlus = `${tahunNow}-${bulanNowPlus}-${tanggalNow}`
        let params = `schedule_date_from=${dateNow}&schedule_date_to=${dateNow}`
        api.create().getReservasiDokterFilter(params).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setAllData(response.data.data)
                    if (response.data.data != false) {
                        let temp = []
                        response.data.data.map(el => {
                            console.log(skriningResult);
                            let a = skrining.findIndex((val) => val.reservasi_id === el.booking_id)
                            if (a < 0) {
                                if (el.appointment_status_name !== "Check-In") {
                                    temp.push(el)
                                }
                            }
                        })
                        setList(temp)
                    } else {
                        setList([])
                    }
                }
            }
        })
    }
    console.log(list);
    console.log(allData);
    console.log(skriningResult);

    const getData = (nama, id, bod) => {
        console.log(nama, id, bod);
        console.log(skriningResult);
        let params;
        let tanggal = new Date(tglLahir).getDate()
        let bulan = new Date(tglLahir).getMonth() + 1 < 10 ? `0${new Date(tglLahir).getMonth() + 1}` : new Date(tglLahir).getMonth() + 1
        let tahun = new Date(tglLahir).getFullYear()
        let tanggalNow = new Date().getDate()
        let bulanNow = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
        let bulanNowPlus = new Date().getMonth() + 2 < 10 ? `0${new Date().getMonth() + 2}` : new Date().getMonth() + 2
        let tahunNow = new Date().getFullYear()
        let dateNow = `${tahunNow}-${bulanNow}-${tanggalNow}`
        let monthPlusNow = `${tahunNow}-${bulanNowPlus}-${tanggalNow}`
        let birthdate = `${tahun}-${bulan}-${tanggal}`
        console.log(birthdate);
        if (idReservasi !== null || namaPasien !== null || tglLahir !== null) {
            params = `schedule_date_from=${dateNow}&schedule_date_to=${dateNow}&booking_id=${idReservasi === null ? "" : idReservasi}&patient_name=${namaPasien === null ? "" : namaPasien}&birth_date=${tglLahir === null ? "" : birthdate}`
            console.log(params);
            api.create().getReservasiDokterFilter(params).then(resp => {
                console.log(resp, '--------------1')
                let arr = []
                if (resp.data) {
                    if (resp.data.status === true) {
                        setAllData(resp.data.data)
                        if (resp.data.data != false) {
                            console.log(resp);
                            resp.data.data.map((el, idx) => {
                                let monthData = new Date(el.doctor_schedule_date).getMonth() + 1
                                let monthNow = new Date().getMonth() + 1
                                let dateData = new Date(el.doctor_schedule_date).getDate()
                                let dateNow = new Date().getDate()
                                console.log(skriningResult);
                                let a = skriningResult.findIndex((val) => val.reservasi_id === el.booking_id)
                                if (monthData >= monthNow) {
                                    if (dateData >= dateNow) {
                                        if (a < 0) {
                                            if (el.appointment_status_name !== "Check-In") {
                                                arr.push(el)
                                            }
                                        }
                                    }
                                }
                            })
                            setList(arr)
                        } else {
                            setList([])
                            // setList(props.data)
                        }
                    }
                }
            })
        } else {
            getAllData(skriningResult)
        }
        console.log(params);
    }

    const getDataFilter = () => {
        let params;
        if (idReservasi !== null) {
            params = `reservasi_id=${idReservasi}`
            if (namaPasien !== null) {
                params = `reservasi_id=${idReservasi}&patient_name=${namaPasien}`
                if (tglLahir !== null) {
                    params = `reservasi_id=${idReservasi}&patient_name=${namaPasien}&birth_date=birth_date`
                }
            }
        }
        console.log(params);
        // api.create().getTransactionScrenningFilter().then(resp => {
        //     console.log(resp)
        //     if (resp.data) {
        //         if (resp.data.status === true) {
        //             if (resp.data.data != false) {
        //                 console.log(resp);
        //                 resp.data.data.map((el, idx) => {
        //                     el["No"] = idx + 1
        //                 })
        //                 setList(resp.data.data)
        //             } else {
        //                 setList([])
        //             }
        //         }
        //     }
        // })
    }

    const handleClick = ({rowData}) => {
        console.log(rowData[1]);
        console.log(is_already);
        let indexAvail = skriningResult.findIndex((val) => val.reservasi_id === rowData[1])
        if (indexAvail < 0) {
            api.create().getFormScrenning().then(response => {
                if (response.data.data) {
                    history.push({
                        pathname: '/skrining/create-skrining-pasien',
                        name: 'Tambah Skrining Pasien',
                        state: {
                            jenisPengunjung: namaPengunjung === "Pilih Pengunjung" ? "Pasien" : namaPengunjung,
                            rowData,
                            data: response.data.data,
                            reservasiId: rowData[1],
                            ttlPasien: rowData[3],
                            namaPasien: rowData[2]
                        }
                    })
                }
            })
        } else {
            if (namaPengunjung !== "Pasien") {
                api.create().getFormScrenning().then(response => {
                    if (response.data.data) {
                        history.push({
                            pathname: '/skrining/create-skrining-pasien',
                            name: 'Tambah Skrining Pasien',
                            state: {
                                jenisPengunjung: namaPengunjung,
                                rowData,
                                data: response.data.data,
                                reservasiId: rowData[1],
                                ttlPasien: rowData[3],
                                namaPasien: rowData[2]
                            }
                        })
                    }
                })
            } else {
                setError(true)
                setMessageError(`${rowData[2]} Sudah melakukan skrining`)
            }
        }
    }

    const handleSimpan = () => {
        api.create().getFormScrenning().then(response => {
            if (response.data.data) {
                history.push({
                    pathname: '/skrining/create-skrining-pasien',
                    name: 'Tambah Skrining Pasien',
                    state: {
                        // rowData,
                        jenisPengunjung: namaPengunjung,
                        data: response.data.data
                    }
                })
            }
        })
    }

    const columns = [
        {
            name: "",
            options: {
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            <GreenRadio
                                title="Pilih"
                                checked={false}
                                onChange={(e) => null}
                                onClick={() => handleClick(tableMeta)}
                                // value="c"
                                name="radio"
                                style={{ padding: 0 }}
                                inputProps={{ 'aria-label': 'C' }}
                            />
                            {/* <LightTooltip arrow>
                                <button style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent'
                                }}
                                    onClick={() => handleClick(tableMeta)}
                                >
                                    <IconSwitch checked={true}
                                    //  checked={tableMeta.rowData[8] === 'Active' ? true : false} 
                                    />
                                </button>
                            </LightTooltip> */}
                        </div>
                    )
                }
            }
        },
        {
            name: 'booking_id',
            label: 'ID Reservasi'
        },
        {
            name: 'patient_name',
            label: 'Nama Pasien'
        },
        {
            name: 'patient_date_of_birth',
            label: 'Tanggal Lahir'
        },
    ]

    const listPengujung = [
        {name: "Pasien"},
        {name: "Pengantar"},
        {name: "Pengunjung"},
    ]

    const handleTambah = () => {
        asuransiLength.push({
            nomor: "",
            nama: ""
        })
        console.log(asuransiLength);
        forceUpdate()
    }

    const handleHapus = (index) => {
        asuransiLength.splice(index, 1)
        forceUpdate()
    }

    const handleNamaAsuransi = (val, index) => {
        asuransiLength[index].nama = val
        forceUpdate()
    }

    const handleNomorAsuransi = (val, index) => {
        asuransiLength[index].nomor = val
        forceUpdate()
    }
    console.log(namaPengunjung);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 30, width: 771, height: namaPengunjung === "Pasien" || namaPengunjung === "Pengantar" || namaPengunjung === "Pilih Pengunjung" ? 569 : namaPengunjung === "Pengunjung" ? 300 : 169, margin: 'auto', overflow: 'scroll' }}>
                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Cari ID Reservasi</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div style={{ maxHeight: 700, overflow: 'scroll', backgroundColor: '#fff' }}>
                    <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                        <div className="column-1">
                            <div className="">
                                <Autocomplete
                                    // multiple
                                    style={{marginTop: 7}}
                                    options={listPengujung}
                                    getOptionLabel={(option) => option.name}
                                    debug
                                    name='Jenis Pengunjung'
                                    id="tipe"
                                    onChange={(event, newInputValue) => {
                                        console.log(newInputValue);
                                        setNamaPengunjung(newInputValue ? newInputValue.name : newInputValue)
                                        setError(false)
                                        setMessageError(null)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                            label="Jenis Pengunjung"
                                        />
                                    }
                                />
                            </div>
                            {
                                namaPengunjung === "Pasien" || namaPengunjung === "Pengantar" ?
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 16 }}
                                        id="namaPasien"
                                        name="namaPasien"
                                        label="Nama Pasien"
                                        required={true}
                                        placeholder={"input nama pasien"}
                                        value={namaPasien}
                                        error={errorNama}
                                        helperText={textNama}
                                        onChange={(e) => {
                                            setNamaPasien(e.target.value)
                                            setErrorNama(false)
                                            setTextNama("")
                                            setError(false)
                                            setMessageError(null)
                                            forceUpdate()
                                            // getData(namaPasien, idReservasi, tglLahir)
                                            // getDataFilter()
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                : null
                            }
                        </div>
                        {
                            namaPengunjung === "Pasien" || namaPengunjung === "Pengantar" ?
                            <div className="column-2">
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 2.5 }}
                                        id="noKtp"
                                        name="noKtp"
                                        label="ID Reservasi"
                                        type=""
                                        placeholder={"Input ID Reservasi"}
                                        error={errorNoKTP}
                                        helperText={textNoKTP}
                                        value={idReservasi}
                                        onChange={(e) => {
                                            setIDReservasi(e.target.value)
                                            setErrorNoKTP(false)
                                            setTextNoKTP("")
                                            setError(false)
                                            setMessageError(null)
                                            // getData(namaPasien, idReservasi, tglLahir)
                                            forceUpdate()
                                            // getDataFilter()
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal Lahir"
                                            label="Tanggal Lahir"
                                            format="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            value={tglLahir}
                                            onChange={(date) => {
                                                setTglLahir(date)
                                                // getDataFilter()
                                                setError(false)
                                                setMessageError(null)
                                                // getData(namaPasien, idReservasi, tglLahir)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            : null
                        }
                    </div>
                    <div style={{ marginTop: 25, display: 'grid', paddingLeft: 50, paddingRight: 50, borderBottom: '1px solid black', width: '87%', margin: 'auto' }}>
                    </div>
                    <div>
                        {
                            error ?
                            <Typography style={{color: '#ff5b5b', textAlignLast: 'start', paddingLeft: 50, paddingTop: 20}}>{messageError}</Typography>
                            : null
                        }
                    </div>
                {
                    namaPengunjung === "Pasien" ?
                    <div style={{ marginTop: 40, paddingLeft: 50, paddingRight: 50, marginBottom: 40 }}>
                        <MuiThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                data={list}
                                columns={columns}
                                options={options}
                            />
                        </MuiThemeProvider>
                    </div>
                    : namaPengunjung === "Pengantar" ?
                    <div style={{ marginTop: 40, paddingLeft: 50, paddingRight: 50, marginBottom: 40 }}>
                        <MuiThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                data={allData}
                                columns={columns}
                                options={options}
                            />
                        </MuiThemeProvider>
                    </div>
                    :null
                }
                </div>
                {
                    namaPengunjung === "Pengunjung" ?
                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                        <div className="column-1" style={{ alignSelf: 'center' }}>
                        </div>
                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                            </div>
                            <div 
                                onClick={(e) => handleSimpan()} 
                                style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} 
                            >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Lanjut</Typography>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        </div>
    )
}